import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import MicroModal from 'micromodal';

export namespace OTPreferencesModal {
	
	let setupModal = () => {
		let links = document.querySelectorAll('.js-onetrust-lead');

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				//MicroModal.init();
				MicroModal.show('modal-onetrust-links', {
					onShow: function () {						
					}
					//onClose: function () {
					//	var emailCheckBox = document.getElementById("ModalEmail")
					//		var textCheckBox = document.getElementById("ModalText")
					//		var whatsappCheckBox = document.getElementById("ModalWhatsApp")

					//		if (!(emailCheckBox.getAttribute("checked") || textCheckBox.getAttribute("checked")
					//			|| whatsappCheckBox.getAttribute("checked"))) {
					//			document.getElementById("OTPreferencesError").classList.add("d-block");
					//			return false;

					//		}
					//		else {
					//			MicroModal.close('modal-onetrust-links'); 
					//		}						
					//}
				});
				//e.preventDefault();
			});
		});

		let iAgreeLinks = document.getElementById('LeadSubmit') as HTMLInputElement;
		
		iAgreeLinks.addEventListener('click', function(e){
			//e.preventDefault();
			const emailCheckBox = document.getElementById("ModalEmail") as HTMLInputElement;
			const textCheckBox = document.getElementById("ModalText") as HTMLInputElement;
			const whatsappCheckBox = document.getElementById("ModalWhatsApp") as HTMLInputElement;
			const newletter = document.getElementById("NewsLetter") as HTMLInputElement;

			if ((emailCheckBox.checked || textCheckBox.checked
				|| whatsappCheckBox.checked) && !newletter.checked) {
				document.getElementById("OTPreferencesError").style.display = "block";
				e.preventDefault();
				return false;
			}
			else {
				document.getElementById("OTPreferencesError").style.display = "none";
				//MicroModal.close('modal-onetrust-links');
			}			
		});		
	}
	export const init = () => {
		setupModal();
	}
}


document.addEventListener('DOMContentLoaded', OTPreferencesModal.init);
